<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sT8tGn/tc-custom/9780226040998.jpg?1722578799420" alt="This image is the cover for the book Tricks of the Trade"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tricks of the Trade
      </h1>
      <p class="bookDescription body article font2">
        <p>Drawing on more than four decades of experience as a researcher and teacher, Howard Becker now brings to students and researchers the many valuable techniques he has learned. <i>Tricks of the Trade</i> will help students learn how to think about research projects. Assisted by Becker's sage advice, students can make better sense of their research and simultaneously generate fresh ideas on where to look next for new data. The tricks cover four broad areas of social science: the creation of the "imagery" to guide research; methods of "sampling" to generate maximum variety in the data; the development of "concepts" to organize findings; and the use of "logical" methods to explore systematically the implications of what is found. Becker's advice ranges from simple tricks such as changing an interview question from "Why?" to "How?" (as a way of getting people to talk without asking for a justification) to more technical tricks such as how to manipulate truth tables.<br/><br/> Becker has extracted these tricks from a variety of fields such as art history, anthropology, sociology, literature, and philosophy; and his dazzling variety of references ranges from James Agee to Ludwig Wittgenstein. Becker finds the common principles that lie behind good social science work, principles that apply to both quantitative and qualitative research. He offers practical advice, ideas students can apply to their data with the confidence that they will return with something they hadn't thought of before.<br/><br/> Like <i>Writing for Social Scientists, Tricks of the Trade</i> will bring aid and comfort to generations of students. Written in the informal, accessible style for which Becker is known, this book will be an essential resource for students in a wide variety of fields.<br/><br/> "An instant classic. . . . Becker's stories and reflections make a great book, one that will find its way into the hands of a great many social scientists, and as with everything he writes, it is lively and accessible, a joy to read."—Charles Ragin, Northwestern University</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howard S. Becker
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df5a010c